import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { ModalWindowModule } from '../modal-window/modal-window.module';
import { MergeInProgressAlertModalComponent } from './merge-in-progress-alert-modal.component';

@NgModule({
  declarations: [MergeInProgressAlertModalComponent],
  imports: [SharedModule, ModalWindowModule],
  exports: [MergeInProgressAlertModalComponent],
})
export class MergeInProgressAlertModalModule {}
